import { useEffect, useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getClientId } from "./clientId";
import { fetchCoins, fetchPumpLaunches, fetchWalletBuys } from "./api";
import { useTrustedCreators } from "./useTrustedCreators";
import { useRugLedger } from "./useRugLedger";
import { mergeSources, getSeenSet } from "./creatorCoins";

export const useCreatorAlerts = () => {
  const clientId = getClientId();
  const { isAlpha } = useTrustedCreators();
  const { isBlockedCreator } = useRugLedger();

  const coinsQ = useQuery({ queryKey: ["coins", "score", "desc", 0, null, ""], queryFn: () => fetchCoins({ sort: "score", order: "desc", min_score: 0 }), refetchInterval: 60000 });
  const launchesQ = useQuery({ queryKey: ["pumpLaunches", "new"], queryFn: () => fetchPumpLaunches("new"), refetchInterval: 20000 });
  const buysQ = useQuery({ queryKey: ["walletBuys", clientId], queryFn: () => fetchWalletBuys(clientId), refetchInterval: 60000 });

  const [seen, setSeen] = useState(getSeenSet);
  useEffect(() => {
    const h = () => setSeen(getSeenSet());
    window.addEventListener("creator-seen-updated", h);
    return () => window.removeEventListener("creator-seen-updated", h);
  }, []);

  const trackedMints = useMemo(() => {
    const merged = mergeSources(coinsQ.data?.coins || [], launchesQ.data?.launches || [], buysQ.data?.tokens || []);
    return merged.filter((i) => isAlpha(i.creator) || isBlockedCreator(i.creator)).map((i) => i.mint);
  }, [coinsQ.data, launchesQ.data, buysQ.data, isAlpha, isBlockedCreator]);

  const newCount = trackedMints.filter((m) => !seen.has(m)).length;
  return { newCount, trackedMints };
};
